module.exports = __webpack_public_path__ + "img/81.e541e961.svg";